import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { useModal } from '../../context/ModalContext';

const PrivateRoute = ({ children, requireRole }) => {
  const location = useLocation();
  const { isAuthenticated, initialized, user } = useSelector(
    (state) => state.auth
  );
  const { showLoginModal } = useModal();

  const target = `${location.pathname}${location.search}${location.hash}`;
  const shouldPromptLogin = initialized && !isAuthenticated;

  useEffect(() => {
    if (shouldPromptLogin) showLoginModal(target);
  }, [shouldPromptLogin, target, showLoginModal]);

  if (!initialized) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Role-gated routes: an authenticated user with the wrong role is sent to
  // their dashboard rather than the restricted page (e.g. only promoters may
  // reach /create-event — brands must never land on event creation).
  if (requireRole && user?.role !== requireRole) {
    return <Navigate to="/dashboard" replace />;
  }

  // T2B-423: /create-event is open to promoters without Easypay — the form
  // saves their event as a draft, and publishing is where the account is
  // required (see the wizard's last step and the API's publish route).

  return children;
};

export default PrivateRoute;
